import {ROOT_PATH} from '@constants/config'

export const PATH_REPORTS = `${ROOT_PATH}reports`
export const PATH_REPORT_BUILDER = `${PATH_REPORTS}/report-builder`
export const PATH_REPORT_RECEIVED = `${PATH_REPORTS}/received`
export const PATH_REPORT_DEVICE_PLANNING_EXECUTION = `${PATH_REPORTS}/device-planning-execution`
export const PATH_REPORT_GROUP_MILEAGE = `${PATH_REPORTS}/group-mileage`
export const PATH_REPORT_FUEL_CONSUMPTION_BY_DEVICE = `${PATH_REPORTS}/fuel-consumption-by-device`
export const PATH_REPORT_FUEL_CONSUMPTION_BY_ROUTE = `${PATH_REPORTS}/fuel-consumption-by-route`
export const PATH_REPORT_SCHEDULE_EXECUTION_BY_ROUTES = `${PATH_REPORTS}/schedule-execution-by-routes`
export const PATH_REPORT_VOYAGE_POINT_DATA = `${PATH_REPORTS}/voyage-point-data`
export const PATH_REPORT_VOYAGE_POINT_AVERAGES = `${PATH_REPORTS}/voyage-point-averages`
export const PATH_REPORT_GROUP_ACTIVE_SESSIONS = `${PATH_REPORTS}/group-active-sessions`
export const PATH_REPORT_ICCIDS = `${PATH_REPORTS}/iccids`
export const PATH_REPORT_CAR_WASH_GEO_ZONE_VISITS = `${PATH_REPORTS}/car-wash-geo-zone-visits`
export const PATH_REPORT_MILEAGE_SUMMARY = `${PATH_REPORTS}/mileage-summary`
export const PATH_REPORT_TRACKER_OUTAGES = `${PATH_REPORTS}/tracker-outages`

export const PATH_MAP = `${ROOT_PATH}map`
export const PATH_SMS_DASHBOARD = `${ROOT_PATH}sms-admin`
export const PATH_STATISTIC = `${ROOT_PATH}statistic`
export const PATH_TRACK_ADVANCED = `${PATH_MAP}/track-advanced`
export const PATH_TRACK_ADVANCED_GROUP = `${PATH_MAP}/track-advanced-group`
export const PATH_AUTO_TRACKING = `${PATH_MAP}/auto-tracking`
export const PATH_AUTO_TRACKING_GROUPS = `${PATH_MAP}/auto-tracking-groups`

export const PATH_MAP_GEO_ZONES = `${PATH_MAP}/geo-zones`
export const PATH_MAP_AREA_SEARCH = `${PATH_MAP}/area-search`

export const PATH_DEVICE_OPERATIONAL_STATISTIC = `${PATH_STATISTIC}/device-operational`
export const PATH_DEVICE_OPERATIONAL_STATISTIC_BY_DEVICES = `${PATH_STATISTIC}/device-operational-by-devices`
export const PATH_GROUPS = `${ROOT_PATH}groups`
export const PATH_VOYAGE_PLANNING = `${ROOT_PATH}voyage/voyage-planning`
export const PATH_VOYAGE_PLANNING_WITH_LOCAL_STATE = `${ROOT_PATH}voyage/voyage-planning-local-state`
export const PATH_BOARDS = `${ROOT_PATH}voyage/boards`
export const PATH_VOYAGE_STADIUM = `${ROOT_PATH}voyage/voyage-stadium`

export const PATH_SINGLE_VOYAGE = `${ROOT_PATH}singleVoyage`

export const PATH_SCHEDULED_SINGLE_VOYAGES = `${PATH_SINGLE_VOYAGE}/scheduled-voyages`
export const PATH_MONITORING_SINGLE_VOYAGES = `${PATH_SINGLE_VOYAGE}/monitoring-voyages`
export const PATH_HISTORY_SINGLE_VOYAGES = `${PATH_SINGLE_VOYAGE}/history-voyages`
export const PATH_ACTIVE_SINGLE_VOYAGES = `${PATH_SINGLE_VOYAGE}/active-voyages`
export const PATH_TASKS_TEMPLATE_SINGLE_VOYAGES = `${PATH_SINGLE_VOYAGE}/tasks-template`
export const PATH_CREATE_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/create`

export const PATH_TASKS_SINGLE_VOYAGES = `${PATH_SINGLE_VOYAGE}/tasks`
export const PATH_TASKS_SINGLE_VOYAGES_WIDTH_ID = `${PATH_TASKS_SINGLE_VOYAGES}/:voyageId`
export const PATH_UPDATE_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/update`
export const PATH_CREATE_FROM_HISTORY_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/create-from-history`
export const PATH_UPDATE_SINGLE_VOYAGE_WIDTH_ID = `${PATH_UPDATE_SINGLE_VOYAGE}/:voyageId`
export const PATH_CREATE_FROM_HISTORY_SINGLE_VOYAGE_WIDTH_ID = `${PATH_CREATE_FROM_HISTORY_SINGLE_VOYAGE}/:voyageId`


export const PATH_ACTIVE_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/active-voyage`
export const PATH_REPORTS_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/reports`
export const PATH_POINTS_TEMPLATES_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/point-templates`
export const PATH_TRACKABLE_OBJECTS_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/trackable-objects`
export const PATH_READERS_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/readers`
export const PATH_VIDEO_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/video`
export const PATH_VOYAGE_TEMPLATES_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/voyage-templates`
export const PATH_CREATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE = `${PATH_VOYAGE_TEMPLATES_SINGLE_VOYAGE}/create`
export const PATH_UPDATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE = `${PATH_VOYAGE_TEMPLATES_SINGLE_VOYAGE}/update`
export const PATH_UPDATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE_WIDTH_ID = `${PATH_UPDATE_VOYAGE_TEMPLATE_SINGLE_VOYAGE}/:templateId`
export const PATH_VOYAGE_TEMPLATE_PLANNING_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/voyage-template-planning`

export const PATH_HISTORY_SINGLE_VOYAGE = `${PATH_SINGLE_VOYAGE}/history-voyage`
export const PATH_ACTIVE_SINGLE_VOYAGE_WIDTH_ID = `${PATH_ACTIVE_SINGLE_VOYAGE}/:voyageId`
export const PATH_HISTORY_SINGLE_VOYAGE_WIDTH_ID = `${PATH_HISTORY_SINGLE_VOYAGE}/:voyageId`
export const PATH_DEVICE_ACTIVITY = `${ROOT_PATH}device-activity`
export const PATH_REPORT_EXECUTION_SINGLE_VOYAGE = `${PATH_REPORTS_SINGLE_VOYAGE}/execution`
export const PATH_REPORT_RFID_SINGLE_VOYAGE = `${PATH_REPORTS_SINGLE_VOYAGE}/rfid`
export const PATH_REPORT_DAILY_EXECUTION_SINGLE_VOYAGE = `${PATH_REPORTS_SINGLE_VOYAGE}/daily-execution`


export const PATH_VOYAGES_AUDIT = `${ROOT_PATH}audit/voyages`


export const PATH_CAMERAS = `${ROOT_PATH}cameras`
export const PATH_CAMERAS_LIST = `${PATH_CAMERAS}/list`
export const PATH_CAMERA_SNAPSHOTS_BY_TIME = `${PATH_CAMERAS}/snaps-by-time`


export const PATH_EMPLOYEES = `${ROOT_PATH}employees`
export const PATH_EMPLOYEES_LIST= `${PATH_EMPLOYEES}/list`
export const PATH_VIDEO = `${ROOT_PATH}video`
export const PATH_VIDEO_STREAMS = `${PATH_VIDEO}/streams`

export const PATH_MONITORING_PLATFORM = `${ROOT_PATH}monitoring-platform`

export const PATH_EQUIPMENT = `${ROOT_PATH}equipment`

export const PATH_DASHBOARD = `${ROOT_PATH}dashboard`
export const PATH_ADMIN_ACCOUNTS = `${ROOT_PATH}admin/accounts`
export const PATH_ADMIN_ACCOUNT_EDIT = `${ROOT_PATH}admin/accounts/:accountId`
export const buildAdminAccountEditPath = (accountId: number) => `${ROOT_PATH}admin/accounts/${accountId}`
export const PATH_ADMIN_USERS = `${ROOT_PATH}admin/users`
export const PATH_ADMIN_USER_NEW = `${ROOT_PATH}admin/users/new`
export const PATH_ADMIN_USER_EDIT = `${ROOT_PATH}admin/users/:userId`
export const buildAdminUserEditPath = (userId: number) => `${ROOT_PATH}admin/users/${userId}`
export const PATH_ADMIN_DEVICES = `${ROOT_PATH}admin/devices`
export const PATH_ADMIN_DEVICE_NEW = `${ROOT_PATH}admin/devices/new`
export const PATH_ADMIN_DEVICE_EDIT = `${ROOT_PATH}admin/devices/:deviceId`
export const buildAdminDeviceEditPath = (deviceId: number) => `${ROOT_PATH}admin/devices/${deviceId}`
export const PATH_ADMIN_EMPLOYEES = `${ROOT_PATH}admin/employees`
export const PATH_ADMIN_EMPLOYEE_NEW = `${ROOT_PATH}admin/employees/new`
export const PATH_ADMIN_EMPLOYEE_EDIT = `${ROOT_PATH}admin/employees/:accountId/:employeeId`
export const buildAdminEmployeeEditPath = (accountId: number, employeeId: number) =>
	`${ROOT_PATH}admin/employees/${accountId}/${employeeId}`
export const PATH_ADMIN_UNREGISTERED = `${ROOT_PATH}admin/unregistered`
